var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import ErrorText from "@irati/ui/src/ErrorText";
export var RadioGroupLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  margin-bottom: 10px;\n"], ["\n  color: ", ";\n  margin-bottom: 10px;\n"])), function (_a) {
    var theme = _a.theme, error = _a.error;
    return (error ? theme.colors.tertiary.r_400 : theme.colors.utility.ink);
});
export var RadioGroupError = styled(ErrorText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 10px;\n"], ["\n  margin-bottom: 10px;\n"])));
export var RadioInput = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  z-index: -1;\n"], ["\n  position: absolute;\n  z-index: -1;\n"])));
export var RadioOptionLabel = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  max-width: none;\n  font-weight: normal;\n  padding: 0;\n  margin: 0 0 1px 0;\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  max-width: none;\n  font-weight: normal;\n  padding: 0;\n  margin: 0 0 1px 0;\n  ", "\n  ", "\n"])), function (_a) {
    var inline = _a.inline;
    return inline && "width: auto;";
}, function (_a) {
    var inline = _a.inline;
    return !inline && "display: flex;";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
